(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    const fileInput = document.getElementById('ContactForm-image');
    const uploadArea = document.getElementById('ContactForm-upload-area');
    const placeholder = document.getElementById('ContactForm-upload-placeholder');
    const preview = document.getElementById('ContactForm-upload-preview');
    const previewImg = document.getElementById('ContactForm-preview-img');
    const filename = document.getElementById('ContactForm-upload-filename');
    const removeBtn = document.getElementById('ContactForm-upload-remove');
    const hiddenInput = document.getElementById('ContactForm-image-data');
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB

    if (!fileInput || !uploadArea) return;

    function handleFile(file) {
      if (!file) return;

      if (!file.type.match(/^image\/(png|jpe?g|webp|gif)$/)) {
        alert('Please upload a PNG, JPG, or WEBP image.');
        return;
      }

      if (file.size > MAX_SIZE) {
        alert('Image is too large. Please choose an image under 5 MB.');
        return;
      }

      const reader = new FileReader();
      reader.onload = function(e) {
        const base64 = e.target.result;
        previewImg.src = base64;
        filename.textContent = file.name;
        placeholder.style.display = 'none';
        preview.style.display = 'flex';
        fileInput.style.display = 'none';
        hiddenInput.value = base64;
      };
      reader.readAsDataURL(file);
    }

    fileInput.addEventListener('change', function() {
      if (this.files && this.files[0]) {
        handleFile(this.files[0]);
      }
    });

    // Drag & drop
    uploadArea.addEventListener('dragover', function(e) {
      e.preventDefault();
      uploadArea.classList.add('dragging');
    });

    uploadArea.addEventListener('dragleave', function() {
      uploadArea.classList.remove('dragging');
    });

    uploadArea.addEventListener('drop', function(e) {
      e.preventDefault();
      uploadArea.classList.remove('dragging');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFile(e.dataTransfer.files[0]);
      }
    });

    // Remove image
    removeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      previewImg.src = '';
      filename.textContent = '';
      preview.style.display = 'none';
      placeholder.style.display = 'flex';
      fileInput.style.display = '';
      fileInput.value = '';
      hiddenInput.value = '';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
